<h2>
  <span>{{
    (
    filter_service.filtersType[1].options.options_selected_subject.asObservable()
    | async
    )?.Series
    }}:
    {{
    (
    $any(filter_service.filtersType[2].options).options_selected_subject.asObservable()
    | async
    )?.CatName
    }}</span>
</h2>
<table class="wa-table">
  <thead class="wa-table__header-group">
    <tr class="wa-table__row">
      <th class="h-ranking sortable wa-table__cell" (click)="changeSort('RANKING')" [ngClass]="rankingSort()">
        <span>{{'Ranking' | transloco}}</span>
      </th>
      <th class="h-name sortable wa-table__cell" [ngClass]="sortClass('NAME')" (click)=" changeSort('NAME')">
        <span>
          {{'Name' | transloco}}</span>
      </th>
      <th class="h-team sortable wa-table__cell" [ngClass]="sortClass('NOC')" (click)="changeSort('NOC')">
        <span>{{'Country' | transloco}}</span>
      </th>
      <th class="h-points sortable wa-table__cell" [ngClass]="sortClass('POINTS')" (click)="changeSort('POINTS')">
        <span>10s</span>
      </th>
    </tr>
  </thead>
  <ng-container *ngIf="athletes.length > 0; else: noresults">
    <tbody class="wa-table__row-group" *ngFor="let athlete of athletes" [athlete]="athlete"
      app-price-for-precision-item class="wa-table__row-group">
    </tbody>
  </ng-container>
  <ng-template #noresults>
    <tbody class="wa-table__row-group">
      <div *ngIf="loading===false" class="status-message status-message--info">{{'no_results' | transloco}} {{(defaultValueMessage|async) | transloco}}</div>
    </tbody>
  </ng-template>

</table>

<div class="status-message status-message--info" *ngIf="loading === true; else: button" class="loading-throbber"></div>

<ng-template #button>
  <div [ngClass]="'load-more-full'" *ngIf="
      pagination !== undefined &&
      athletes.length !== pagination.totalResults
    "
    (click)="loadMore()">
    {{'load_more' | transloco}}
  </div>
</ng-template>
